export type MetaMaskConnectionMode = 'default' | 'flask';

export const LOCAL_FLASK_SNAP_ID = 'local:http://localhost:8086';
const STORAGE_KEY = 'ducat-metamask-connection-mode';
let currentMode: MetaMaskConnectionMode | undefined;

/** The local Snap is an explicit development option, never a production fallback. */
export function isFlaskConnectionAvailable(hostname = typeof window === 'undefined' ? '' : window.location?.hostname): boolean {
  return (
    process.env.NEXT_PUBLIC_FEATURE_METAMASK_FLASK_ON === 'true' &&
    ['dev.app.ducatprotocol.com', 'dev-ducat.vercel.app', 'localhost', '127.0.0.1', '[::1]'].includes(hostname ?? '')
  );
}

export function getMetaMaskConnectionMode(): MetaMaskConnectionMode {
  if (!isFlaskConnectionAvailable()) return 'default';
  if (currentMode === undefined) {
    try {
      currentMode = window.sessionStorage.getItem(STORAGE_KEY) === 'flask' ? 'flask' : 'default';
    } catch {
      currentMode = 'default';
    }
  }
  return currentMode;
}

export function setMetaMaskConnectionMode(mode: MetaMaskConnectionMode): void {
  if (mode === 'flask' && !isFlaskConnectionAvailable()) throw new Error('MetaMask Flask is disabled for this deployment.');
  currentMode = mode;
  try {
    // Per-tab storage keeps a second tab's wallet selection from changing an active connection.
    window.sessionStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // The explicit selection still works when browser storage is unavailable.
  }
}
